<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="buttonFrame">
        <el-button @click="editDialogVisible = true" type="primary" size="medium">新增</el-button>
      </div>
      <el-pagination background layout="prev, pager, next" :current-page="pageNum" @current-change="pageChange"
        :total="totalNum">
      </el-pagination>
      <div>
        <el-table :data="productAreas" tooltip-effect="dark" style="width: 100%" border>
          <el-table-column label="版本号" align="center" prop="appVersion">
          </el-table-column>
          <el-table-column prop="fileUrl" label="路径" show-overflow-tooltip align="center">
          </el-table-column>
          <el-table-column label="描述" prop="remark" align="center"></el-table-column>
          <el-table-column label="是否启用" show-overflow-tooltip align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.isEnable" active-color="#13ce66" inactive-color="#ff4949" active-value="1"
                inactive-value="0"></el-switch>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 新增弹出窗 -->
    <div>
      <el-dialog title="新增" :visible.sync="editDialogVisible" width="50%" :modal="false" :before-close="beforeClose">
        <el-form label-position="left" label-width="80px" :model="formData">
          <el-form-item label="版本号:">
            <el-input v-model="formData.appVersion"></el-input>
          </el-form-item>
          <el-form-item label="版本描述:">
            <el-input v-model="formData.remark"></el-input>
          </el-form-item>
          <el-form-item label="是否启用:">
            <el-switch v-model="formData.isEnable" active-color="#13ce66" inactive-color="#ff4949" active-value="1"
              inactive-value="0">
            </el-switch>
          </el-form-item>
          <el-form-item label="文件:">
            <el-upload action="string" class="upload-demo" :on-remove="handleManyRemove" :limit="10"
              :file-list="fileList" :http-request="uploadManyFile" :auto-upload="true">
              <el-button size="medium" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import {
    Loading
  } from 'element-ui'
  import {
    PUBLIC_URL
  } from 'api/config'
  import {
    appManagerFunc,
    appUploadFile,
    confirmFunc
  } from 'api/request'
  import {
    loadingInstance,
    Success,
    Error
  } from 'common/js/util'
  import MSidebar from 'components/header/sidebar'
  import MHeader from 'components/header/header'
  export default {
    data() {
      return {
        productAreas: [],
        editDialogVisible: false,
        formData: {
          isEnable: "1",
          fileUrl: ''
        },
        pageNum: 1,
        totalNum: 10,
        fileList: []
      }
    },
    components: {
      MSidebar,
      MHeader
    },
    methods: {
      getList() {
        appManagerFunc({
          current: this.pageNum,
          pages: this.totalNum
        }).then((res) => {
          console.log(res)
          if (res.status == 200) {
            this.productAreas = res.data.records
            this.totalNum = res.data.pages
            this.pageNum = res.data.current
          }
        })
      },
      // 确认提交
      confirm() {
        if (this.formData.fileUrl !== undefined) {
          confirmFunc(this.formData).then((res) => {
            if (res.status === 200) {
              Success(this, res)
              this.getList()
              this.editDialogVisible = false
              this.resetFunc()
            }
          })
          return
        }
      },
      pageChange(val) {
        this.pageNum = val
        this.getList()
      },
      // 文件列表移除文件时的钩子
      handleManyRemove(file, fileList) {
        if (fileList.length == 0) {
          this.formData.fileUrl = "";
        }
      },
      uploadManyFile(param) {
        const that = this
        let form = new FormData();
        let fileObj = param.file;
        form.append("file", fileObj);
        form.append("type", 302);
        loadingInstance(Loading)
        appUploadFile(form).then((res) => {
          if (res.status == 200) {
            // 赋值
            that.assignment(res.data)
          }
        })
      },
      resetFunc() {
        this.formData = {
          isEnable: "1",
          fileUrl: undefined,
          remark: undefined,
          appVersion: undefined
        }
        // 钩子fileList
        this.fileList = []
      },
      beforeClose(done) {
        this.resetFunc()
        done()
      },
      cancel() {
        this.resetFunc()
        this.editDialogVisible = false
      },
      assignment(data) {
        this.formData.fileUrl = data
        loadingInstance(Loading).close()
      }
    },
    created() {
      this.getList()
    }
  }
</script>

<style scoped>
  .buttonFrame {
    margin: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/system/appManage.vue